import cx from 'classnames';
import Link from 'next/link';
import { ComponentProps, FunctionComponent, MouseEventHandler } from 'react';

import classes from './background.module.css';

const variants: { [key: string]: string } = {
  DEFAULT: 'bg-white',
  SECONDARY: 'bg-neutral-10',
  DARK: 'bg-neutral-50 text-white',
};

const BackgroundLink: FunctionComponent<
  ComponentProps<typeof Link> & {
    variant?: 'DEFAULT' | 'SECONDARY' | 'DARK';
    isFlex?: boolean;
    onClick?: MouseEventHandler<HTMLAnchorElement>;
    className?: string;
  }
> = ({
  variant = 'DEFAULT',
  children,
  onClick,
  isFlex = true,
  className,
  ...props
}) => (
  <Link
    {...props}
    className={cx(
      variants[variant],
      classes.link,
      { 'flex flex-1': isFlex },
      className
    )}
    {...(onClick && { onClick: onClick })}
  >
    {children}
  </Link>
);
export default BackgroundLink;
